import styled from "styled-components"
import { Dialog } from "@mui/material"

const RailGroupManagementWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .header-bar {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 800;
      color: var(--cms-text-primary);
      letter-spacing: -0.01em;
    }

    .create-btn {
      border-radius: 10px;
      text-transform: none;
      font-weight: 700;
      min-height: 40px;
      padding: 8px 14px;
      box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
    }
  }

  .groups {
    padding: 6px 0 0;
    width: 100%;
    max-width: 100%;
    margin: 0;

    .rail-group {
      cursor: move;
      font-size: 14px;
      background: var(--cms-surface-secondary);
      border: 1px solid var(--cms-border);
      box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
      border-radius: 12px;
      padding: 14px;
      color: var(--cms-text-primary);
      margin-bottom: 10px;

      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .content {
        font-size: 13px;
        width: 80%;
        .info-section {
          width: 100%;
          padding: 0px 5px;
          margin-bottom: 5px;
          .label {
            margin-right: 15px;
            display: inline-block;
            background: #edf4ff;
            color: #1e40af;
            padding: 3px 10px;
            min-width: 100px;
            border-radius: 999px;
            font-weight: 700;
          }

          .rule-tag {
            display: inline-block;
            background: #0f766e;
            margin: 0px 8px 3px 0;
            padding: 3px 5px;
            border-radius: 3px;
            color: white;
            text-transform: capitalize;
          }

          .rail-list {
            display: inline-block;
            .rail-item {
              display: inline-block;
              background: #475569;
              margin: 0px 8px 3px 0;
              padding: 3px 5px;
              border-radius: 3px;
              color: white;
            }
          }
        }
      }

      .actions {
        .MuiIconButton-root {
          margin-left: 5px;
        }
      }
    }

    .empty-state {
      border: 1px dashed var(--cms-border);
      border-radius: 12px;
      background: var(--cms-surface-muted);
      padding: 26px 16px;
      text-align: center;
      color: var(--cms-text-secondary);
      font-weight: 600;
    }
  }
`

const StyledRailGroupDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  .MuiPaper-root {
    width: min(900px, calc(100vw - 28px));
    min-width: 0;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }
  .error {
    font-size: 0.75rem;
    color: #d32f2f;
    margin-top: 3px;
  }
  .label-text {
    font-weight: 700;
    font-size: 13px;
    line-height: 1.4375em;
    color: var(--cms-text-primary);
  }

  .rail-select-region {
    .list-label {
      font-size: 15px;
      font-weight: 700;
      margin-bottom: 10px;
      color: var(--cms-text-primary);
    }
    .MuiBox-root {
      box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,
        rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
      height: 250px;
      overflow-y: scroll;
      border-radius: 5px;
    }
    p {
      font-size: 14px;
      color: var(--cms-text-secondary);
      font-weight: 600;
    }
  }

  .rule-settings {
    background-color: var(--cms-surface-muted);
    padding: 20px;
    margin-top: 10px;
    font-size: 15px;
    color: var(--cms-text-secondary);
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    input,
    select,
    .uiSelect-select {
      color: var(--cms-text-primary);
    }

    .random-rule-input-panel {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      font-size: 15px;
      .num-of-random-num {
        width: 70px;
        margin: 0 10px;
        color: var(--cms-text-primary);
      }
      .target {
        min-width: 200px;
        margin: 0 10px;
      }
    }
  }
`

export { RailGroupManagementWrapper, StyledRailGroupDialog }
